import { useState, useEffect } from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/og_logo.webp';

function AppNavbar({ className }) {
  const location = useLocation();
  const [expanded, setExpanded] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <Navbar
      bg="dark"
      expand="lg"
      className={`ogs-navbar ${className || ''} ${scrolled ? 'ogs-navbar-scrolled' : ''}`}
      expanded={expanded}
      onToggle={(val) => setExpanded(val)}
    >
      <Container>
        <Navbar.Brand as={Link} to="/" className="d-flex align-items-center ogs-navbar-brand">
          <img src={logo} alt="OGS Logo" className="ogs-navbar-logo me-3" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="main-navbar-nav" />
        <Navbar.Collapse id="main-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link
              as={Link}
              to="/"
              className={location.pathname === '/' ? 'ogs-active-link' : ''}
              onClick={() => setExpanded(false)}
            >
              Home
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/about"
              className={location.pathname === '/about' ? 'ogs-active-link' : ''}
              onClick={() => setExpanded(false)}
            >
              About Us
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/vision"
              className={location.pathname === '/vision' ? 'ogs-active-link' : ''}
              onClick={() => setExpanded(false)}
            >
              Vision & Mission
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/contact"
              className={location.pathname === '/contact' ? 'ogs-active-link' : ''}
              onClick={() => setExpanded(false)}
            >
              Contact Us
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default AppNavbar;
